import React from 'react'
import ThemeImage from 'cms/CmsCaptionImage'

const Image = ({
  defaultContent,
  defaultContent: {
    caption,
    captionPosition,
  },
  deviceContent = {},
  screen,
  goto,
  style,
  assets: {
    defaultImage
  },
  settings,
  renderElement,
}) => {
  const deviceData = deviceContent[screen]
  const useDeviceData = deviceData && deviceData.source
  // override image in specific device
  const { link, source, target } = useDeviceData ? deviceData : defaultContent
  return (
    renderElement(
      ThemeImage,
      {
        style,
        ...settings,
        wrapperStyle: style,
        src: source || '',
        defaultImage,
        link, // for display cursor when hover
        caption,
        captionPosition,
        ...link && { onClick: () => goto({ href: link, target }) },
      }
    )
  )
}

Image.propTypes = {}
Image.defaultProps = {}

export default Image



// WEBPACK FOOTER //
// ./src/components/Canvas/renderer/elements/image/Image.js